import React from 'react';
import { hydrate } from 'react-dom';
import { loadableReady } from '@loadable/component';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';

import Root from '@/components/Root';
import { config } from '@/config';
import configureStore from '@/store';

require('@/assets/styles/normalize.less');
require('@/assets/styles/main.less');

const initialState = window.APP_INITIAL_STATE;
const routerBasename = window.APP_ROUTER_BASENAME;
const templateParams = window.APP_TEMPLATE_PARAMS || {};

delete window.APP_INITIAL_STATE;
delete window.APP_ROUTER_BASENAME;
delete window.APP_TEMPLATE_PARAMS;

if (config.sentryEnabled) {
  Sentry.init({
    dsn: config.sentryDsnClient,
    environment: config.sentryEnv,
    integrations: [
      new BrowserTracing({
        tracingOrigins: config.sentryTracingOrigins,
      }),
    ],
    tracesSampleRate: 1.0,
  });
}

if (window.location.origin === initialState?.payment?.deployUrl) {
  const store = configureStore(initialState);

  const rootElement = document.getElementById('root');

  const render = Component => {
    hydrate(
      <Component
        store={store}
        routerBasename={routerBasename}
        templateParams={templateParams}
        env="client"
      />,
      rootElement
    );
  };

  loadableReady(() => {
    if (module.hot) {
      module.hot.accept('@/components/Root', () => {
        const Component = require('@/components/Root').default; //eslint-disable-line

        render(Component);
      });
    }

    render(Root);
  });
}
